<section class="lead-capture-container overflow-hidden position-relative">
    <div class="position-absolute top-0 start-0" [ngClass]="{'lead-container-disable':save_contact_state === LEAD_SAVE_CONTACT_STATE.SAVING}">
    </div>
    <div class="px-4 pt-3">
        <p class="text-dark mt-1 mb-2 fs-3">Add Contact</p>
        <div class="captured-image position-relative w-100 rounded-2 shadow">
            <div
                class="w-100 h-100 rounded-2 position-absolute top-0 start-0"
                *ngIf="current_lead_state !== LEAD_STATE.EDIT"
            >
                <app-processing-loader
                    [loadingMessage]="'Processing image data...'"
                    [status]="current_lead_state === LEAD_STATE.ERROR_PARSING ? 'error' : current_lead_state"
                ></app-processing-loader>
            </div>
            <img [src]="tempCapturedURLData" class="w-100 h-100 rounded-2"
                [ngClass]="{
                    'border border-success': image_processing_state === AFTER_IMAGE_PROCESSING.SUCCESS,
                    'border border-danger': image_processing_state === AFTER_IMAGE_PROCESSING.INVALID,
                }"
                alt="CapturedFrame" *ngIf="tempCapturedURLData"
            />
            <button
                *ngIf="current_lead_state === LEAD_STATE.EDIT" (click)="handleRetakeImage()" 
                class="file-upload-label position-absolute bottom-0 end-0 rounded-circle bg-light border border-transparent"
            >
                <img
                    src="/img/icons/refresh-icon.svg"
                    alt="RefreshIcon"
                    width="18px"
                    height="18px"
                />
            </button>
        </div>

        <form *ngIf="current_lead_state !== LEAD_STATE.ERROR_PARSING" [formGroup]="businessCardLeadFieldForm">
            <div
                class="form-fields d-flex flex-column gap-3 mt-4"
                [ngClass]="{'is-loading':current_lead_state === LEAD_STATE.PARSING}"
            >
                <div class="form-input w-100">
                    <label for="firstNameInput" class="form-label mb-0">
                        First name
                    </label>
                    <input id="firstNameInput" type="text" class="form-control" formControlName="first_name" [disabled]="isFieldDisable" required="true" />
                    <small class="text-danger" *ngIf="ERROR_MESSAGE_FORM[CONTACT_FIELD_FORM.FIRST_NAME]">
                        {{ ERROR_MESSAGE_FORM[CONTACT_FIELD_FORM.FIRST_NAME] }}
                    </small>
                </div>
                <div class="form-input w-100">
                    <label for="lastNameInput" class="form-label mb-0">
                        Last name
                    </label>
                    <input id="lastNameInput" type="text" class="form-control" formControlName="last_name" [disabled]="isFieldDisable" required="true" />
                    
                    <small class="text-danger" *ngIf="ERROR_MESSAGE_FORM[CONTACT_FIELD_FORM.LAST_NAME]">
                        {{ ERROR_MESSAGE_FORM[CONTACT_FIELD_FORM.LAST_NAME] }}
                    </small>
                </div>
                <div class="form-input w-100">
                    <label for="emailInput" class="form-label mb-0">
                        Email
                    </label>
                    <input id="emailInput" type="email" class="form-control" formControlName="email" [disabled]="isFieldDisable" required="true" />
                    <small class="text-danger" *ngIf="ERROR_MESSAGE_FORM[CONTACT_FIELD_FORM.EMAIL]">
                        {{ ERROR_MESSAGE_FORM[CONTACT_FIELD_FORM.EMAIL] }}
                    </small>
                </div>
                <div class="form-input w-100">
                    <label for="contactNameInput" class="form-label mb-0">
                        Phone
                    </label>
                    <input
                        type="tel" class="form-control" id="contactNameInput" formControlName="phone"
                        [disabled]="isFieldDisable"
                    />
                    <small class="text-danger" *ngIf="ERROR_MESSAGE_FORM[CONTACT_FIELD_FORM.PHONE]">
                        {{ ERROR_MESSAGE_FORM[CONTACT_FIELD_FORM.PHONE] }}
                    </small>
                </div>

                <div class="form-input w-100">
                    <label for="designationInput" class="form-label mb-0">
                        Job title
                    </label>
                    <input type="text" class="form-control" id="designationInput" formControlName="designation" [disabled]="isFieldDisable" />
                </div>
                <div class="form-input w-100">
                    <label for="companyNameInput" class="form-label mb-0">
                        Company name
                    </label>
                    <input type="text" class="form-control" id="companyNameInput" formControlName="company" [disabled]="isFieldDisable" />
                </div>
            </div>
        </form>

        <!-- Error State -->
        <div class="error-state text-center mt-5" *ngIf="current_lead_state === LEAD_STATE.ERROR_PARSING">
            <p class="fs-1 fw-500">Details not detected</p>
            <p>
                Ensure the image details are clear to save the contact from the
                card.
            </p>

            <button
                type="button" class="btn btn-primary btn-light-primary w-100 text-light rounded-1"
                (click)="handleRetakeImage()"
            >
                Retake Image
            </button>
            <button
                type="button" class="btn btn-transparent w-100 border border-secondary rounded-1 mt-3"
                (click)="handleEnterDetails()"
            >
                Enter Contact Details
            </button>
        </div>

        <div class="w-100 position-fixed bottom-0 start-0">
            <!-- ALERT STATE -->
            <div
                class="p-3"
                [ngClass]="{
                    'bg-success d-flex gap-2': image_processing_state === AFTER_IMAGE_PROCESSING.SUCCESS || save_contact_state === LEAD_SAVE_CONTACT_STATE.SUCCESS,
                    'bg-danger d-flex gap-2': image_processing_state === AFTER_IMAGE_PROCESSING.INVALID || current_lead_state === LEAD_STATE.ERROR_PARSING || save_contact_state === LEAD_SAVE_CONTACT_STATE.ERROR,
                }"
            >
                <div *ngIf="image_processing_state === AFTER_IMAGE_PROCESSING.SUCCESS">
                    <img
                        src="/img/icons/check-circle.svg"
                        alt="Close"
                        width="20"
                        height="20"
                    />
                    <span class="ms-3">Image processed successfully</span>
                </div>

                <div *ngIf="save_contact_state === LEAD_SAVE_CONTACT_STATE.SUCCESS">
                    <img
                        src="/img/icons/check-circle.svg"
                        alt="Close"
                        width="20"
                        height="20"
                    />
                    <span class="ms-3">Contact saved successfully</span>
                </div>

                <div *ngIf="image_processing_state === AFTER_IMAGE_PROCESSING.INVALID || current_lead_state === LEAD_STATE.ERROR_PARSING || save_contact_state === LEAD_SAVE_CONTACT_STATE.ERROR">
                    <img
                        src="/img/icons/exclamation-message.svg"
                        alt="Close"
                        width="20"
                        height="20"
                    />
                    <span class="ms-3">
                        {{ save_contact_state === LEAD_SAVE_CONTACT_STATE.ERROR ? 'Unable to add contact. Please try again.' : 'Image processing failed.' }}
                    </span>
                </div>
            </div>

            <!-- BUTTON STATE -->
            <div class="add-contact-button p-3" *ngIf="current_lead_state !== LEAD_STATE.ERROR_PARSING">
                <button
                    (click)="submitLead()" class="btn text-light w-100"
                    [disabled]="businessCardLeadFieldForm.invalid"
                >
                    <span *ngIf="save_contact_state !== LEAD_SAVE_CONTACT_STATE.SAVING">
                        Add
                    </span>

                    <span *ngIf="save_contact_state === LEAD_SAVE_CONTACT_STATE.SAVING">
                        <div class="spinner mx-auto"></div>
                    </span>
                </button>
            </div>
        </div>
    </div>
</section>
